// extracted by mini-css-extract-plugin
export var address = "contact-module--address--3fn7K";
export var contact = "contact-module--contact--yUVT2";
export var contactForm = "contact-module--contactForm--eyRAD";
export var container = "contact-module--container--DCZVC";
export var heading = "contact-module--heading--KPYqx";
export var portrait = "contact-module--portrait--IKm7Z";
export var subtitle = "contact-module--subtitle--iPyvn";
export var validate = "contact-module--validate--129lI";
export var wrapper = "contact-module--wrapper--GUCpN";